import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RfcPortal from "./RfcPortal";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RfcPortal />
  </React.StrictMode>
);
